module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForWin_pic6.7f02100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForWin/dataLeakInstallForWin_pic6.png
// module id = 497
// module chunks = 1